// extracted by mini-css-extract-plugin
export default {"menu":"BoardMembershipsStep_menu__Yum-r"};